import React from 'react';
import PropTypes from 'prop-types';
import Recording from './recording';


const RecordingListItem = ({ createDateTime, sid }) => (
  <tr>
    <td>
      {createDateTime.toLocaleString()}
    </td>
    <td><Recording sid={sid} /></td>
  </tr>
);

RecordingListItem.propTypes = {
  createDateTime: PropTypes.instanceOf(Date).isRequired,
  sid:            PropTypes.string.isRequired
};

export default RecordingListItem;
